var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topic",class:{clickable: _vm.action != null},on:{"click":_vm.execute}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.publicIcon+_vm.icon}})]),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }